<template>
    <div class="form-builder-field" :class="{'validation-error':validationError}">
        <label class="form-label">{{ description.label }}</label><br>
        <div class="form-builder-field-field">
            <span class="prepend" v-if="description.prepend">{{ description.prepend }}</span>
            <component v-if="token" :ref="token.key" :is="getComponent" :token="token" v-model="innerValue"
                       @validate="handleValidateField"></component>
            <span class="append" v-if="description.append">{{ description.append }}</span>
        </div>
        <div class="error-messages" v-if="validationError" @click="hideValidationError">
            <ul>
                <li v-for="message in validationErrorMessages">{{ message }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import Utils from '@s/utils.js'

    import String from '@c/plugins/formbuilder/elements/String'
    import Password from '@c/plugins/formbuilder/elements/Password'
    import List from '@c/plugins/formbuilder/elements/List'
    import TagsManager from '@c/plugins/formbuilder/elements/TagsManager'

    import customvalidators from '@s/formValidators'
    import validatorjs from 'validatorjs'
    import validatorjsFR from 'validatorjs/src/lang/fr'

    import FormElementMixin from '@/mixins/formElement.js'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            String,
            Password,
            List,
            TagsManager
        },
        computed: {
            getComponent() {
                if (this.description.component) {
                    return this.description.component
                }
                else if (this.token.type.indexOf('array') != -1) {

                }
                else {
                    return Utils.capitalizeFirstLetter(this.token.type)
                }
            },

            innerValue: {
                get() {
                    return this.value
                },
                set(value) {
                    this.updateValue(value)
                    /*if(this.validator.type){
                        this.validateField(value)
                    }*/

                }
            },

            validator() {
                let validator = {
                    type: null,
                    value: null
                }


                if (this.token.validator.client) {
                    if (this.token.validator.client.type) {
                        validator.type = this.token.validator.client.type
                        validator.value = this.token.validator.client.value
                    }
                    else {
                        validator.type = "validatorjs"
                        validator.value = this.token.validator.client
                    }
                } else if (!this.token.validator.server) {
                    if (this.token.validator.type) {
                        validator.type = this.token.validator.type
                        validator.value = this.token.validator.value
                    }
                    else {
                        validator.type = "validatorjs"
                        validator.value = this.token.validator
                    }
                }


                if (validator.value != null) {
                    if (validator.value.indexOf('bail|') !== -1) {
                        validator.value = validator.value.replace('bail|', '')
                    }
                }


                return validator
            }
        },
        created: function () {

        },
        data() {
            return {
                validationError: false,
                validationErrorMessages: []
            }
        },
        destroyed: function () {

        },
        methods: {

            handleValidateField() {
                if (this.validator.type) {
                    this.validateField(this.innerValue)
                }
            },

            validateField(value) {


                switch (this.validator.type) {
                    case 'RegExp': {
                        break;
                    }
                    case 'Function': {
                        return customvalidators[this.token.validator.client.value](value)
                        break;
                    }
                    case 'validatorjs': {
                        let rules = {}
                        let values = {}
                        if (!this.token.optionnal) {
                            if(this.token.type.indexOf('array') != -1){
                                rules[this.token.key+'.*'] = "required|" + this.validator.value
                            }
                            else{
                                rules[this.token.key] = "required|" + this.validator.value
                            }

                        }
                        else {
                            if(this.token.type.indexOf('array') != -1){
                                rules[this.token.key+'.*'] = this.validator.value
                            }
                            else{
                                rules[this.token.key] = this.validator.value
                            }

                        }


                        console.log('rules',rules)


                        values[this.token.key] = value

                        let validation = new validatorjs(values, rules)

                        validation.setAttributeFormatter(attribute => {
                            return '"'+this.description.label+'"'
                        })

                        if (validation.fails()) {
                            this.validationError = true;
                            this.validationErrorMessages = validation.errors.all()[this.description.token]
                            if(this.token.type.indexOf('array') != -1) {
                                this.validationErrorMessages = validation.errors.all()[Object.keys(validation.errors.all())[0]]
                            }
                        }
                        else {
                            this.validationError = false;
                            this.validationErrorMessages = []
                        }

                        //console.log(rules,values,validation.passes(),validation.errors)
                        return {
                            success: validation.passes(),
                            errors: validation.errors
                        }

                        break;
                    }
                }


            },

            hideValidationError(){
                this.validationError = false
                this.validationErrorMessages = []
            }

        },
        mixins: [
            FormElementMixin
        ],
        mounted: function () {
            validatorjs.setMessages('fr', validatorjsFR);
            validatorjs.useLang('fr')
        },
        name: '',
        props: {
            description: {
                type: Object,
                required: true
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .form-builder-field {
        display: flex;
        position: relative;
        margin-bottom: 20px;

        label {
            flex: 0 0 200px;
            font-weight: $bold;
        }

        .form-builder-field-field {
            flex: 1 1 100%;
            display:flex;

            &>span{
                &.prepend,&.append{
                    background-color: $main-color;
                    color: $main-white;
                    flex: 1 1 auto;
                    line-height: $form-elements-line-height;
                    white-space: nowrap;
                }
                &.prepend{
                    padding: 0 5px 0 10px;
                    border-radius: var(--input-radius) 0 0 var(--input-radius);
                }
                &.append{
                    padding: 0 10px 0 5px;
                    border-radius: 0 var(--input-radius) var(--input-radius) 0;
                }
                &.field{
                    flex: 1 1 100%;

                }
                &.prepend + .field{
                    >*{
                        border-radius: 0;
                    }
                }

            }


        }

        .error-messages {
            position: absolute;
            right: 0;
            top: 0;
            background-color: $error;
            color: $main-white;
            transform: translate(calc(100% + 10px), 0);
            padding: 10px;
            max-width: 300px;
            cursor: pointer;

            ul{
                list-style: none;
                padding: 0;
                margin: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/Field.vue